import { get } from '../api/common';
const forteApplicationApiPrefix = '/WebApi/api/forte-application';
export var AccountType;
(function (AccountType) {
    AccountType[AccountType["Checking"] = 0] = "Checking";
    AccountType[AccountType["Savings"] = 1] = "Savings";
})(AccountType || (AccountType = {}));
export var ForteApplicationStatus;
(function (ForteApplicationStatus) {
    ForteApplicationStatus["Unsubmitted"] = "unsubmitted";
    ForteApplicationStatus["Received"] = "received";
    ForteApplicationStatus["Approved"] = "approved";
    ForteApplicationStatus["Pending"] = "pending";
    ForteApplicationStatus["Declined"] = "declined";
    ForteApplicationStatus["Enrolled"] = "enrolled";
    ForteApplicationStatus["Rejected"] = "rejected";
    ForteApplicationStatus["Recalled"] = "recalled";
})(ForteApplicationStatus || (ForteApplicationStatus = {}));
export var ApplicantOrganizationBusinessOwnershipType;
(function (ApplicantOrganizationBusinessOwnershipType) {
    ApplicantOrganizationBusinessOwnershipType["CCorporation"] = "c_corporation";
    ApplicantOrganizationBusinessOwnershipType["Government"] = "government";
    ApplicantOrganizationBusinessOwnershipType["LimitedLiabilityCorporation"] = "limited_liability_corporation";
    ApplicantOrganizationBusinessOwnershipType["PartnershipGeneralOrLimited"] = "partnership_general_or_limited";
    ApplicantOrganizationBusinessOwnershipType["PubliclyHeldCorporation"] = "publicly_held_corporation";
    ApplicantOrganizationBusinessOwnershipType["SCorporation"] = "s_corporation";
    ApplicantOrganizationBusinessOwnershipType["SoleProprietorship"] = "sole_proprietorship";
    ApplicantOrganizationBusinessOwnershipType["TaxExemptOrNonProfitOrganization"] = "tax_exempt_or_non_profit_organization";
})(ApplicantOrganizationBusinessOwnershipType || (ApplicantOrganizationBusinessOwnershipType = {}));
export var ApplicantOrganizationBusinessType;
(function (ApplicantOrganizationBusinessType) {
    ApplicantOrganizationBusinessType["A10100"] = "A10100";
    ApplicantOrganizationBusinessType["A10200"] = "A10200";
    ApplicantOrganizationBusinessType["A10300"] = "A10300";
    ApplicantOrganizationBusinessType["A10400"] = "A10400";
    ApplicantOrganizationBusinessType["A10500"] = "A10500";
    ApplicantOrganizationBusinessType["A10600"] = "A10600";
    ApplicantOrganizationBusinessType["A10700"] = "A10700";
    ApplicantOrganizationBusinessType["A10800"] = "A10800";
    ApplicantOrganizationBusinessType["A10900"] = "A10900";
    ApplicantOrganizationBusinessType["A11000"] = "A11000";
    ApplicantOrganizationBusinessType["A11100"] = "A11100";
    ApplicantOrganizationBusinessType["A11200"] = "A11200";
    ApplicantOrganizationBusinessType["A11300"] = "A11300";
    ApplicantOrganizationBusinessType["A11400"] = "A11400";
    ApplicantOrganizationBusinessType["A11500"] = "A11500";
    ApplicantOrganizationBusinessType["A11600"] = "A11600";
    ApplicantOrganizationBusinessType["A11700"] = "A11700";
    ApplicantOrganizationBusinessType["A11800"] = "A11800";
    ApplicantOrganizationBusinessType["A11900"] = "A11900";
    ApplicantOrganizationBusinessType["A12000"] = "A12000";
    ApplicantOrganizationBusinessType["A12100"] = "A12100";
    ApplicantOrganizationBusinessType["A12200"] = "A12200";
    ApplicantOrganizationBusinessType["B20100"] = "B20100";
    ApplicantOrganizationBusinessType["B20200"] = "B20200";
    ApplicantOrganizationBusinessType["B20300"] = "B20300";
    ApplicantOrganizationBusinessType["B20400"] = "B20400";
    ApplicantOrganizationBusinessType["B20500"] = "B20500";
    ApplicantOrganizationBusinessType["C30100"] = "C30100";
    ApplicantOrganizationBusinessType["C30200"] = "C30200";
    ApplicantOrganizationBusinessType["C30300"] = "C30300";
    ApplicantOrganizationBusinessType["C30400"] = "C30400";
    ApplicantOrganizationBusinessType["C30500"] = "C30500";
    ApplicantOrganizationBusinessType["C30600"] = "C30600";
    ApplicantOrganizationBusinessType["C30700"] = "C30700";
    ApplicantOrganizationBusinessType["C30800"] = "C30800";
    ApplicantOrganizationBusinessType["C30900"] = "C30900";
    ApplicantOrganizationBusinessType["C31000"] = "C31000";
    ApplicantOrganizationBusinessType["C31100"] = "C31100";
    ApplicantOrganizationBusinessType["C31200"] = "C31200";
    ApplicantOrganizationBusinessType["C31300"] = "C31300";
    ApplicantOrganizationBusinessType["C31400"] = "C31400";
    ApplicantOrganizationBusinessType["D40100"] = "D40100";
    ApplicantOrganizationBusinessType["D40200"] = "D40200";
    ApplicantOrganizationBusinessType["D40300"] = "D40300";
    ApplicantOrganizationBusinessType["D40400"] = "D40400";
    ApplicantOrganizationBusinessType["D40500"] = "D40500";
    ApplicantOrganizationBusinessType["D40600"] = "D40600";
    ApplicantOrganizationBusinessType["D40700"] = "D40700";
    ApplicantOrganizationBusinessType["D40800"] = "D40800";
    ApplicantOrganizationBusinessType["D40900"] = "D40900";
    ApplicantOrganizationBusinessType["D41000"] = "D41000";
    ApplicantOrganizationBusinessType["D41100"] = "D41100";
    ApplicantOrganizationBusinessType["D41200"] = "D41200";
    ApplicantOrganizationBusinessType["D41300"] = "D41300";
    ApplicantOrganizationBusinessType["D41400"] = "D41400";
    ApplicantOrganizationBusinessType["D41500"] = "D41500";
    ApplicantOrganizationBusinessType["D41600"] = "D41600";
    ApplicantOrganizationBusinessType["D41700"] = "D41700";
    ApplicantOrganizationBusinessType["D41800"] = "D41800";
    ApplicantOrganizationBusinessType["D41900"] = "D41900";
    ApplicantOrganizationBusinessType["D42000"] = "D42000";
    ApplicantOrganizationBusinessType["D42100"] = "D42100";
    ApplicantOrganizationBusinessType["D42200"] = "D42200";
    ApplicantOrganizationBusinessType["D42300"] = "D42300";
    ApplicantOrganizationBusinessType["E50100"] = "E50100";
    ApplicantOrganizationBusinessType["E50200"] = "E50200";
    ApplicantOrganizationBusinessType["E50300"] = "E50300";
    ApplicantOrganizationBusinessType["E50400"] = "E50400";
    ApplicantOrganizationBusinessType["E50500"] = "E50500";
    ApplicantOrganizationBusinessType["E50600"] = "E50600";
    ApplicantOrganizationBusinessType["E50700"] = "E50700";
    ApplicantOrganizationBusinessType["F60100"] = "F60100";
    ApplicantOrganizationBusinessType["F60200"] = "F60200";
    ApplicantOrganizationBusinessType["F60300"] = "F60300";
    ApplicantOrganizationBusinessType["F60400"] = "F60400";
    ApplicantOrganizationBusinessType["F60500"] = "F60500";
    ApplicantOrganizationBusinessType["F60600"] = "F60600";
    ApplicantOrganizationBusinessType["F60700"] = "F60700";
    ApplicantOrganizationBusinessType["F60800"] = "F60800";
    ApplicantOrganizationBusinessType["F60900"] = "F60900";
    ApplicantOrganizationBusinessType["F61000"] = "F61000";
    ApplicantOrganizationBusinessType["F61100"] = "F61100";
    ApplicantOrganizationBusinessType["F61200"] = "F61200";
    ApplicantOrganizationBusinessType["F61300"] = "F61300";
    ApplicantOrganizationBusinessType["F61400"] = "F61400";
    ApplicantOrganizationBusinessType["F61500"] = "F61500";
    ApplicantOrganizationBusinessType["F61600"] = "F61600";
    ApplicantOrganizationBusinessType["F61700"] = "F61700";
    ApplicantOrganizationBusinessType["F61800"] = "F61800";
    ApplicantOrganizationBusinessType["F61900"] = "F61900";
    ApplicantOrganizationBusinessType["F62000"] = "F62000";
    ApplicantOrganizationBusinessType["F62100"] = "F62100";
    ApplicantOrganizationBusinessType["F62200"] = "F62200";
    ApplicantOrganizationBusinessType["F62300"] = "F62300";
    ApplicantOrganizationBusinessType["F62400"] = "F62400";
    ApplicantOrganizationBusinessType["F62500"] = "F62500";
    ApplicantOrganizationBusinessType["F62600"] = "F62600";
    ApplicantOrganizationBusinessType["F62700"] = "F62700";
    ApplicantOrganizationBusinessType["F62800"] = "F62800";
    ApplicantOrganizationBusinessType["F62900"] = "F62900";
    ApplicantOrganizationBusinessType["F63000"] = "F63000";
    ApplicantOrganizationBusinessType["F63100"] = "F63100";
    ApplicantOrganizationBusinessType["F63200"] = "F63200";
    ApplicantOrganizationBusinessType["F63300"] = "F63300";
    ApplicantOrganizationBusinessType["F63400"] = "F63400";
    ApplicantOrganizationBusinessType["F63500"] = "F63500";
    ApplicantOrganizationBusinessType["F63600"] = "F63600";
    ApplicantOrganizationBusinessType["F63700"] = "F63700";
    ApplicantOrganizationBusinessType["F63800"] = "F63800";
    ApplicantOrganizationBusinessType["F63900"] = "F63900";
    ApplicantOrganizationBusinessType["F64000"] = "F64000";
    ApplicantOrganizationBusinessType["F64100"] = "F64100";
    ApplicantOrganizationBusinessType["F64200"] = "F64200";
    ApplicantOrganizationBusinessType["G70100"] = "G70100";
    ApplicantOrganizationBusinessType["G70200"] = "G70200";
    ApplicantOrganizationBusinessType["G70300"] = "G70300";
    ApplicantOrganizationBusinessType["G70400"] = "G70400";
    ApplicantOrganizationBusinessType["G70500"] = "G70500";
    ApplicantOrganizationBusinessType["G70600"] = "G70600";
    ApplicantOrganizationBusinessType["G70700"] = "G70700";
    ApplicantOrganizationBusinessType["G70800"] = "G70800";
    ApplicantOrganizationBusinessType["G70900"] = "G70900";
    ApplicantOrganizationBusinessType["G71000"] = "G71000";
    ApplicantOrganizationBusinessType["G71100"] = "G71100";
    ApplicantOrganizationBusinessType["G71200"] = "G71200";
    ApplicantOrganizationBusinessType["G71300"] = "G71300";
    ApplicantOrganizationBusinessType["G71400"] = "G71400";
    ApplicantOrganizationBusinessType["G71500"] = "G71500";
    ApplicantOrganizationBusinessType["G71600"] = "G71600";
    ApplicantOrganizationBusinessType["G71700"] = "G71700";
    ApplicantOrganizationBusinessType["G71800"] = "G71800";
    ApplicantOrganizationBusinessType["G71900"] = "G71900";
    ApplicantOrganizationBusinessType["G72000"] = "G72000";
    ApplicantOrganizationBusinessType["G72100"] = "G72100";
    ApplicantOrganizationBusinessType["G72200"] = "G72200";
    ApplicantOrganizationBusinessType["G72300"] = "G72300";
    ApplicantOrganizationBusinessType["G72400"] = "G72400";
    ApplicantOrganizationBusinessType["G72500"] = "G72500";
    ApplicantOrganizationBusinessType["G72600"] = "G72600";
    ApplicantOrganizationBusinessType["G72700"] = "G72700";
    ApplicantOrganizationBusinessType["G72800"] = "G72800";
    ApplicantOrganizationBusinessType["G72900"] = "G72900";
    ApplicantOrganizationBusinessType["G73000"] = "G73000";
    ApplicantOrganizationBusinessType["G73100"] = "G73100";
    ApplicantOrganizationBusinessType["G73200"] = "G73200";
    ApplicantOrganizationBusinessType["G73300"] = "G73300";
    ApplicantOrganizationBusinessType["G73400"] = "G73400";
    ApplicantOrganizationBusinessType["G73500"] = "G73500";
    ApplicantOrganizationBusinessType["G73600"] = "G73600";
    ApplicantOrganizationBusinessType["G73700"] = "G73700";
    ApplicantOrganizationBusinessType["G73800"] = "G73800";
    ApplicantOrganizationBusinessType["G73900"] = "G73900";
    ApplicantOrganizationBusinessType["G74000"] = "G74000";
    ApplicantOrganizationBusinessType["G74100"] = "G74100";
    ApplicantOrganizationBusinessType["G74200"] = "G74200";
    ApplicantOrganizationBusinessType["G74300"] = "G74300";
    ApplicantOrganizationBusinessType["H80100"] = "H80100";
    ApplicantOrganizationBusinessType["H80200"] = "H80200";
    ApplicantOrganizationBusinessType["H80300"] = "H80300";
    ApplicantOrganizationBusinessType["H80400"] = "H80400";
    ApplicantOrganizationBusinessType["H80500"] = "H80500";
    ApplicantOrganizationBusinessType["H80600"] = "H80600";
    ApplicantOrganizationBusinessType["H80700"] = "H80700";
    ApplicantOrganizationBusinessType["H80800"] = "H80800";
    ApplicantOrganizationBusinessType["H80900"] = "H80900";
    ApplicantOrganizationBusinessType["H81000"] = "H81000";
    ApplicantOrganizationBusinessType["H81100"] = "H81100";
    ApplicantOrganizationBusinessType["H81200"] = "H81200";
    ApplicantOrganizationBusinessType["H81300"] = "H81300";
    ApplicantOrganizationBusinessType["H81400"] = "H81400";
    ApplicantOrganizationBusinessType["H81500"] = "H81500";
    ApplicantOrganizationBusinessType["H81600"] = "H81600";
    ApplicantOrganizationBusinessType["H81700"] = "H81700";
    ApplicantOrganizationBusinessType["H81800"] = "H81800";
    ApplicantOrganizationBusinessType["H81900"] = "H81900";
    ApplicantOrganizationBusinessType["H82000"] = "H82000";
    ApplicantOrganizationBusinessType["I90100"] = "I90100";
    ApplicantOrganizationBusinessType["I90200"] = "I90200";
    ApplicantOrganizationBusinessType["I90300"] = "I90300";
    ApplicantOrganizationBusinessType["I90400"] = "I90400";
    ApplicantOrganizationBusinessType["I90500"] = "I90500";
    ApplicantOrganizationBusinessType["I90600"] = "I90600";
    ApplicantOrganizationBusinessType["I90700"] = "I90700";
    ApplicantOrganizationBusinessType["I90800"] = "I90800";
    ApplicantOrganizationBusinessType["I90900"] = "I90900";
    ApplicantOrganizationBusinessType["I91000"] = "I91000";
    ApplicantOrganizationBusinessType["I91100"] = "I91100";
    ApplicantOrganizationBusinessType["I91200"] = "I91200";
    ApplicantOrganizationBusinessType["I91300"] = "I91300";
})(ApplicantOrganizationBusinessType || (ApplicantOrganizationBusinessType = {}));
export var OwnerTitle;
(function (OwnerTitle) {
    OwnerTitle["CEO"] = "ceo";
    OwnerTitle["CFO"] = "cfo";
    OwnerTitle["COO"] = "coo";
    OwnerTitle["ManagingMember"] = "managing_member";
    OwnerTitle["GeneralPartner"] = "general_partner";
    OwnerTitle["President"] = "president";
    OwnerTitle["VicePresident"] = "vice_president";
    OwnerTitle["Treasurer"] = "treasurer";
    OwnerTitle["Other"] = "other";
})(OwnerTitle || (OwnerTitle = {}));
export const createOrUpdateApplication = async (data) => {
    const result = await fetch(`${forteApplicationApiPrefix}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!result.ok) {
        throw new Error(`Failed to save forte application: ${result.statusText}`);
    }
};
export const getApplication = async () => {
    const result = await get(`${forteApplicationApiPrefix}`);
    if (!result.ok) {
        throw new Error(`Failed to get current forte application: ${result.statusText}`);
    }
    return result.json();
};
export const getBusinessCategoriesAndTypes = async () => {
    const result = await get(`${forteApplicationApiPrefix}/business-category-type-mapping`);
    if (!result.ok) {
        throw new Error(`Failed to get business categories and types: ${result.statusText}`);
    }
    return result.json();
};
export const submitForteApplication = async () => {
    const result = await fetch(`${forteApplicationApiPrefix}/submit`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!result.ok) {
        const json = await result.json();
        throw new Error(json.Message);
    }
};
export const getForteApplicationStatus = async () => {
    const result = await get(`${forteApplicationApiPrefix}/status`);
    if (!result.ok) {
        throw new Error(`Failed to get forte application status: ${result.statusText}`);
    }
    return result.json();
};
